import axios from "axios"

function getProposalsCount() {
    return axios.get(`/api/v1/user/proposals/counts`)
}

export const groupAttributionService = {
    getProposalsCount,
}
